/**
 * Customer-facing wording for PDF packs, matching frontend/src/utils/packWording.js.
 * Pack names are admin data ("…: Set 1", "…: Full bundle (Sets 1–4)"), so the friendlier
 * wording is applied when rendering and works for existing purchases without editing them.
 */

/** "Set 3" → "Paper 3", "Sets 1–4" → "Papers 1–4", "full bundle" → "Complete Pack", in free text. */
export function friendlySetWording(text) {
  return String(text || "")
    .replace(/\bSets\b/g, "Papers")
    .replace(/\bsets\b/g, "papers")
    .replace(/\bSet\b/g, "Paper")
    .replace(/\bset\b/g, "paper")
    .replace(/\bfull bundle\b/gi, "Complete Pack")
    .replace(/\bbundle\b/gi, "pack");
}

/** Splits "…: Set 1" into { family: "…", title: "Practice Paper 1" }. */
export function splitPackName(name) {
  const text = String(name || "");
  const idx = text.lastIndexOf(":");
  const family = idx >= 0 ? text.slice(0, idx).trim() : "";
  const short = (idx >= 0 ? text.slice(idx + 1) : text).trim();
  const set = /^set\s+(\d+)$/i.exec(short);
  const full = /^full bundle\s*(\(.*\))?$/i.exec(short);
  let title;
  if (set) title = `Practice Paper ${set[1]}`;
  else if (full) title = `Complete Pack${full[1] ? ` ${friendlySetWording(full[1])}` : ""}`;
  else title = friendlySetWording(short);
  return { family, title };
}

/** "…: Set 1" → "…: Practice Paper 1". */
export function friendlyPackName(name) {
  const { family, title } = splitPackName(name);
  return family ? `${family}: ${title}` : title;
}
